import type { MultilingualConfigValue, MultilingualNodeConfig } from "../../schemas/index.ts";
import { isMultilingualProperty } from "./filterFunctions.ts";

interface Options {
  supportedLanguageCodes: Readonly<string[]>;
}

export const stripUnsupportedTranslationsCreate = ({ supportedLanguageCodes }: Options) => {
  const stripUnsupportedTranslations = (value: MultilingualConfigValue): MultilingualConfigValue => {
    if (!value) {
      return value;
    }

    if (Array.isArray(value)) {
      return value.map(stripUnsupportedTranslations);
    }

    if (typeof value === "object") {
      if (isMultilingualProperty(value)) {
        return {
          __ml: Object.fromEntries(
            Object.entries(value.__ml).filter(([lang]) => supportedLanguageCodes.includes(lang)),
          ),
        };
      }

      return Object.fromEntries(
        Object.entries(value).map(([name, propValue]) => [name, stripUnsupportedTranslations(propValue)]),
      );
    }
    return value;
  };

  return (config: MultilingualNodeConfig) =>
    Object.fromEntries(
      Object.entries(config).map(([name, value]): [string, MultilingualConfigValue] => [
        name,
        stripUnsupportedTranslations(value),
      ]),
    );
};
